export const CONTACT_DETAILS = {
  addressLines: ['AP Complex, Kuttikattoor,', 'Calicut, Kerala - 673008'],
  phones: ['+91 7907 30 40 50', '+91 96452 87355'],
  email: 'eracreatiodevelopers@gmail.com',
  whatsappNumber: '917907304050',
  workingHours: {
    weekdays: 'Monday - Saturday: 9:00 AM - 6:00 PM',
    sunday: 'Sunday: By Appointment',
  },
};
